import { Modal } from 'iview';
var beforeClose = {
  before_close_normal: function before_close_normal(resolve) {
    Modal.confirm({
      title: '确定要关闭这一页吗',
      onOk: function onOk() {
        resolve(true);
      },
      onCancel: function onCancel() {
        resolve(false);
      }
    });
  }
};
export default beforeClose;